import { generateRandomString } from 'flow/utils';
import { addHeadsetLogEntry } from 'flow/utils/browser-utils';

export default class HeadsetInterface {
    constructor(deviceInfo) {
        this._deviceInfo = deviceInfo;
        this._id = generateRandomString();
        const logString =
            '[Headsets] Connected - [' +
            this.deviceInfo.ManufacturerName +
            '|' +
            this.id +
            ']';
        addHeadsetLogEntry(logString);
        console.info(logString);
    }
    get deviceInfo() {
        return this._deviceInfo;
    }
    get id() {
        return this._id;
    }
    // Functions for sending events to the headset
    incomingCall(callId) {
        addHeadsetLogEntry("App -> headset: Signaling 'incoming call'");
        this.incomingCallImpl(callId);
    }
    incomingCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    outgoingCall(callId) {
        addHeadsetLogEntry("App -> headset: Signaling 'outgoing call'");
        this.outgoingCallImpl(callId);
    }
    outgoingCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    confirmCall(callId, incoming, answeredThroughHeadset) {
        addHeadsetLogEntry("App -> headset: Signaling 'confirm call'");
        this.confirmCallImpl(callId, incoming, answeredThroughHeadset);
    }
    confirmCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    endCall(callId, hungupThroughHeadset) {
        addHeadsetLogEntry("App -> headset: Signaling 'end call'");
        this.endCallImpl(callId, hungupThroughHeadset);
    }
    endCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    muteCall(callId) {
        addHeadsetLogEntry("App -> headset: Signaling 'mute call'");
        this.muteCallImpl(callId);
    }
    muteCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    unmuteCall(callId) {
        addHeadsetLogEntry("App -> headset: Signaling 'unmute call'");
        this.unmuteCallImpl(callId);
    }
    unmuteCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    holdCall(callId) {
        addHeadsetLogEntry("App -> headset: Signaling 'hold call'");
        this.holdCallImpl(callId);
    }
    holdCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    resumeCall(callId) {
        addHeadsetLogEntry("App -> headset: Signaling 'resume call'");
        this.resumeCallImpl(callId);
    }
    resumeCallImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    // Callbacks to the Webapp, for execution upon events from the headset
    attachCallbacks(/*callbacks*/) {
        addHeadsetLogEntry("can't attach callbacks to unknown device");
    }
    onDisconnect() {
        const logString = '[Headsets] - Disconnected - [' + this.id + ']';
        addHeadsetLogEntry(logString);
        console.info(logString);
        this.onDisconnectImpl();
    }
    onDisconnectImpl() {
        addHeadsetLogEntry('Not implemented for this headset');
    }
    userUnavailable() {
        // Not doing anything if not implemented
    }
    userAvailable() {
        // Not doing anything if not implemented
    }
    logError(description, errorObject) {
        addHeadsetLogEntry(description + ' ' + JSON.stringify(errorObject));
    }
}
